// @flow

type TArg = $ReadOnly<{ widgetMode: string }>;

const checkActiveWidget = ({ widgetMode }: TArg) =>
	widgetMode === 'widget-edit' || widgetMode === 'widget-resize';

export default checkActiveWidget;
